import DeleteConfirmation from "components/modal/delete-confirmation"
import ChartChildDeleteConfirmation from "components/asset-management/chart/controls/chart-child-delete-confirmation"
import InputTypeAtRest from "components/asset-management/chart/controls/input-type-at-rest"
import ChildCount from "components/asset-management/chart/controls/child-count"

export default {
  DetailedStub: () => { return null },
  DeleteConfirmation,
  ChartChildDeleteConfirmation,
  InputTypeAtRest,
  ChildCount
}
